import uuidv4 from '@form-engine/core-util/uuid';
import { FormDefinition } from '@form-engine/core-application/types/form';
import useFormApi from '@form-engine/builder-application/hooks/use-form-api';
import useMounted from '@form-engine/core-application/hooks/use-mounted';
import { useCallback } from 'react';
import FormEngine from '@form-engine/core-application/index';
import Builder from '@form-engine/builder-application/index';
import { toast } from 'react-toastify';
import openFile from '@form-engine/builder-application/utilities/open-file';

export async function importFormFromFile() {
    const fileContents = await openFile('Form Projects', {
        'application/x-form-engine-project': ['.xfe'],
    });

    return JSON.parse(fileContents) as FormDefinition;
}

export function useImportForm() {
    const formApi = useFormApi();
    const mounted = useMounted();

    const callback = useCallback(
        async (persist = true) => {
            let formDefinition;
            try {
                formDefinition = await importFormFromFile();
            } catch {
                toast.error(Builder.i18n.c('import-form.corrupted-error'));
            }

            if (formDefinition?.engineVersion) {
                if (
                    parseInt(formDefinition?.engineVersion.split('.')[0], 10) <
                    parseInt(FormEngine.version.split('.')[0], 10)
                ) {
                    toast.error(Builder.i18n.c('import-form.version-error'));
                    return;
                }

                delete formDefinition.engineVersion;
            }

            if (!mounted || !formDefinition) return;

            if (!persist) {
                return formDefinition;
            }

            formDefinition.id = uuidv4();
            formDefinition.name = `${formDefinition.name} (Imported)`;
            return await formApi.create(formDefinition);
        },
        [formApi]
    );

    return callback;
}
